import {Component, h} from "preact";
import styles from "./style.module.scss"
import {icons} from '../icons';
import actions from "../../store/actions";
import {i18nService} from "../../services/i18n-service";
import {connect} from "redux-zero/preact";
import {withDeviceIndicator} from "../../hoc/withDeviceIndicator";
import {config} from "../../config";
import Input from "../input";

interface Props {
  closeInterstitial();

  isMobile: boolean;
}

interface State {
  emailValue: string;
  passwordValue: string;
  showError: boolean;
  disableLoginButton: boolean;
  saveLogin: boolean;
  isEmailValid: boolean;
}

class Interstitial extends Component<Props, State> {

  state: State = {
    emailValue: '',
    passwordValue: '',
    showError: false,
    disableLoginButton: true,
    saveLogin: false,
    isEmailValid: false
  };


  constructor() {
    super();
    this.handleCloseOnBackground = this.handleCloseOnBackground.bind(this);
    this.handleCloseOnX = this.handleCloseOnX.bind(this);
    this.handleBack = this.handleBack.bind(this);
    this.handleLogin = this.handleLogin.bind(this);
    this.handleValidation = this.handleValidation.bind(this);
    this.handleStayLoggedIn = this.handleStayLoggedIn.bind(this);
  }

  componentDidMount() {
    document.documentElement.style.overflow = 'hidden';
  }

  componentWillUnmount() {
    document.documentElement.style.overflow = 'visible';
  }

  handleCloseOnBackground(e: Event) {
    if (e.target === e.currentTarget) {
      this.props.closeInterstitial();
    }
  }

  handleCloseOnX() {
    this.props.closeInterstitial();
  }

  handleBack() {
    this.props.closeInterstitial();
  }


  handleValidation() {
    if (!this.getEmailValidationLogic(this.state.emailValue) || this.state.passwordValue === '') {
      this.setState({disableLoginButton: true});
      return false;
    } else {
      this.setState({disableLoginButton: false});
      return true;
    }
  }

  countryHasLoyalty(): boolean {
    let CountryService = null;
    if (window['NY_COUNTRY_SERVICE']) {
      CountryService = window['NY_COUNTRY_SERVICE'];
    }
    if (CountryService && CountryService.currentCountry) {
      return CountryService.currentCountry.loyalty;
    }
  }

  handleStayLoggedIn(e) {
    this.setState({saveLogin: e.target.checked});
  }

  async handleLogin() {
    if (this.handleValidation()) {
      this.setState({showError: false, disableLoginButton: true});
      let CustomerService = null;
      if (window && window['NY_CUSTOMER_SERVICE']) {
        CustomerService = window['NY_CUSTOMER_SERVICE'];
      }
      if (!CustomerService) {
        console.error("no NY_CUSTOMER_SERVICE available");
        this.setState({showError: true, disableLoginButton: false});
        return;
      }

      try {
        const customer = await CustomerService.login(this.state.emailValue, this.state.passwordValue, this.state.saveLogin);
        customer ? this.props.closeInterstitial() : this.setState({showError: true});
      } catch {
        this.setState({showError: true});
      } finally {
        this.setState({disableLoginButton: false});
      }
    }
  }

  performEmailValidation = (email) => {
    this.setState({isEmailValid: (email && !this.getEmailValidationLogic(email))})
  }

  getEmailValidationLogic = (email) => {
    if(!email) return false;
    const regex = new RegExp('^([a-zA-Z0-9_\\-\\.]+)@([a-zA-Z0-9_\\-\\.]+)\\.([a-zA-Z]{2,5})$');
    return regex.test(email.toString());
  }

  render() {
    return (
      <div class={styles["interstitial-background"]} onClick={this.handleCloseOnBackground}>
        <div class={styles["interstitial-container"]}>
          {!this.props.isMobile &&
            <span class={styles.close} onClick={this.handleCloseOnX}>{icons.renderCloseIcon()}</span>}
          {this.props.isMobile &&
            <span class={styles.back} onClick={this.handleBack}>{icons.renderArrowLeftIcon()}</span>}
          <div class={styles.content}>
            {this.countryHasLoyalty() && <div class={styles['logo-container']}>
              <img src={`${config.publicPath}images/logos/GetMore.png`} alt={'GET MORE Logo'}/>
            </div>}
            <div class={styles['text-container']}>
              <div class={styles['info']}>
                {!this.state.showError && i18nService.translate('login_info_text')}
              </div>
              {this.state.showError && <div class={styles['error']}>
                <div class={styles['exclamation-point']}>
                  {icons.renderExclamationPoint()}
                </div>
                <div class={styles['error-message']}>
                  {i18nService.translate('login_error_text')}
                </div>
              </div>}
            </div>
            <div className={styles['login-inputs']}>
              <Input type={'email'}
                     placeholder={i18nService.translate('login_input_email')}
                     required={true}
                     autocomplete={'email'}
                     onInputCallback={(value: string) => {
                       this.setState({emailValue: value}, () => this.handleValidation());
                     }}
                     onEnterCallback={this.handleLogin}
                     onFocusOut={() => this.performEmailValidation(this.state.emailValue)}
              />

              {
                this.state.isEmailValid && (
                      <div className={styles.error}>
                        <svg className={styles['error-icon']} xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512">
                          <path d="M504 256c0 136.997-111.043 248-248 248S8 392.997 8 256C8 119.083 119.043 8 256 8s248 111.083 248
                                  248zm-248 50c-25.405 0-46 20.595-46 46s20.595 46 46 46 46-20.595 46-46-20.595-46-46-46zm-43.673-165.346l7.418
                                  136c.347 6.364 5.609 11.346 11.982 11.346h48.546c6.373 0 11.635-4.982
                                  11.982-11.346l7.418-136c.375-6.874-5.098-12.654-11.982-12.654h-63.383c-6.884 0-12.356 5.78-11.981 12.654z"
                          />
                        </svg>
                        <span className={styles['error-info']}>{i18nService.translate('login_warning_valid_email_address')}</span>
                      </div>
                  )
              }


              <Input type={'password'}
                     placeholder={i18nService.translate('login_input_password')}
                     required={true}
                     autocomplete={'password'}
                     onInputCallback={(value: string) => {
                       this.setState({passwordValue: value}, () => this.handleValidation());
                     }}
                     onEnterCallback={this.handleLogin}/>
            </div>
            <div class={styles["stay-logged-reset-password-container"]}>
              <div>
                <input onClick={this.handleStayLoggedIn} type="checkbox"
                       class={styles["product-client-checkbox"]} id="product-client-checkbox"
                       name="product-client-checkbox"/>
                <label class={styles["product-client-checkbox-label"]}
                       htmlFor="product-client-checkbox">{i18nService.translate('login_checkbox_stay_logged_in')}</label>
              </div>
              
              <ny-button buttonType={'text-button'} actionType={'secondary'} onClick={() => location.href = '/customer-profile/#/public/customer-profile/reset-password'}>
                <span slot={'buttonLabel'}>{i18nService.translate('login_button_reset_password')}</span>
              </ny-button>
            </div>
            <div class={styles['login-buttons']}>
              <ny-button buttonType={'standard-width-button'} actionType={'primary'} disabled={this.state.disableLoginButton} onClick={this.handleLogin}>
                <span slot={'buttonLabel'}>{i18nService.translate('login_button_login')}</span>
              </ny-button>
            </div>
          </div>
        </div>
      </div>
    )
  }
}

export default connect(null, actions)(withDeviceIndicator(Interstitial));